import { z } from 'zod';

import { zodInvoiceDetailSchema } from '../useQueryInvoiceDetail/validations';

import { INVOICE_IMPORT_MAX_FILES } from './constants';

// One staged upload: the file id from `files/upload_link` plus the name and
// MIME type the API needs to tell the invoice PDF/XML apart.
export const zodImportInvoiceFileSchema = z.object({
  contentType: z.string(),
  fileId: z.string().min(1),
  filename: z.string(),
});

export const zodImportInvoicePayloadSchema = z.object({
  files: z
    .array(zodImportInvoiceFileSchema)
    .min(1)
    .max(INVOICE_IMPORT_MAX_FILES),
  ownerCompanyId: z.uuid(),
});

export const zodImportInvoiceResponseSchema = z.object({
  data: z.array(zodInvoiceDetailSchema),
});
